import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    schoolType: "",
    district: "",
    schoolID: null,
    studentName: "",
    course: null,
    courseName: "",
}

export const studentSlice = createSlice({
    name: "student",
    initialState,
    reducers: {
        addSchoolType: (state, action) => {
            state.schoolType = action.payload
        },
        addDistrict: (state, action) => {
            state.district = action.payload
        },
        addSchoolID: (state, action) => {
            state.schoolID = action.payload
        },
        addStudentName: (state, action) => {
            state.studentName = action.payload
        },
        addCourse: (state, action) => {
            state.course = action.payload
        },
        addCourseName: (state, action) => {
            state.courseName = action.payload
        },
    }
})

export const { addSchoolType, addDistrict, addSchoolID, addStudentName, addCourse, addCourseName, addChapter, addChapterName } = studentSlice.actions

export const selectSchoolType = (state) => state.student.schoolType

export const selectDistrict = (state) => state.student.district

export const selectSchoolID = (state) => state.student.schoolID

export const selectStudentName = (state) => state.student.studentName

export const selectCourse = (state) => state.student.course

export const selectCourseName = (state) => state.student.courseName

export default studentSlice.reducer